import { resources } from "@constants/hardcoded-strings";
import {
    AttributesValidationErrors,
} from "@idw-types/common/validation/verification-service-details-validation-errors/verification-service-details-validation-errors";
import { FormattedRpServiceConfigurationAttribute, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";

export const getAttributesValidationErrors = (
    activeServices: Array<FormattedRpServiceConfigurationServiceOffering>,
    activeAttributes: Array<FormattedRpServiceConfigurationAttribute>
): AttributesValidationErrors => {

    let count = 0;
    let attributesError = null;
    if (activeServices.length === 0 && activeAttributes.length === 0) {
        count += 1;
        attributesError = (
            <ErrorAlert>
                <div>
                    <span>In order to minimally configure this verification service, add <b>at least one</b> of <b>either</b>:</span>
                    <ul>
                        <li>An attribute in this section</li>
                        <li>Or, a service in any category under Services</li>
                    </ul>
                </div>
            </ErrorAlert>
        );
    }

    return {
        attributesError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.attributes.tabName} errorCount={count} />
    };
};
